import React from "react";
import { useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Un seul Toaster pour toutes les pages de l'app. Il n'était monté que sur le
// tableau de bord : les pages BD, mini-site et assistant appelaient toast() dans
// le vide, et une erreur comme « Character introuvable » ne s'affichait jamais.
// Le formulaire client garde le sien (en haut au centre) : en monter un second
// afficherait chaque message en double.
export default function RouteToaster() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/formulaire/")) return null;
  return <Toaster position="top-right" richColors />;
}
